// Helper functions for handling example project skip logic

const SKIP_DURATION_MS = 60 * 60 * 1000; // 1 hour in milliseconds

/**
 * Checks if we should skip duplication for example projects
 * Only works on localhost
 */
export const shouldSkipDuplication = (): boolean => {
  // Only allow skipping duplication on localhost
  if (window.location.hostname !== 'localhost') return false;
  
  const skipUntil = localStorage.getItem('skipDuplicationUntil');
  if (!skipUntil) return false;
  
  const skipUntilDate = new Date(skipUntil);
  return skipUntilDate > new Date();
};

/**
 * Prompts the user to skip duplication for 1 hour
 * Returns true if user confirmed, false otherwise
 * Only shows prompt on localhost
 */
export const promptSkipDuplication = (): boolean => {
  // On non-localhost domains, always duplicate
  if (window.location.hostname !== 'localhost') return false;
  
  const confirmed = window.confirm(
    'Do you want to duplicate this project?'
  );
  
  if (!confirmed) {
    const oneHourFromNow = new Date(Date.now() + SKIP_DURATION_MS);
    localStorage.setItem('skipDuplicationUntil', oneHourFromNow.toISOString());
  }
  
  return !confirmed;
};

/**
 * Resets the skip flag from localStorage
 */
export const resetSkipFlag = (): void => {
  localStorage.removeItem('skipDuplicationUntil');
};

/**
 * Checks if the skip flag exists in localStorage
 */
export const hasSkipFlag = (): boolean => {
  return localStorage.getItem('skipDuplicationUntil') !== null;
}; 